// menu-fixes.js (updated) — uses delayed close to avoid accidental disappearing
document.addEventListener('DOMContentLoaded', function () {
  const nav = document.querySelector('nav#AccessibleNav');
  if (!nav) return;

  const topItems = Array.from(nav.querySelectorAll('ul.dt-desktop-menu > li'));
  const closeTimers = new WeakMap();
  const CLOSE_DELAY = 250; // ms - tweak between 150-350 as needed

  function clearTimer(li) {
    const t = closeTimers.get(li);
    if (t) {
      clearTimeout(t);
      closeTimers.delete(li);
    }
  }
  function scheduleClose(li) {
    clearTimer(li);
    const timer = setTimeout(() => {
      li.classList.remove('is-open');
      const trigger = li.querySelector('a, button');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      closeTimers.delete(li);
    }, CLOSE_DELAY);
    closeTimers.set(li, timer);
  }

  function openImmediate(li) {
    clearTimer(li);
    // close other items
    topItems.forEach(i => {
      if (i !== li) {
        i.classList.remove('is-open');
        const t = i.querySelector('a, button');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });
    li.classList.add('is-open');
    const trigger = li.querySelector('a, button');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  topItems.forEach(li => {
    const hasSub = li.querySelector('ul.sub-menu-lists, .megamenu_megamenu .sub-menu-block');
    if (!hasSub) return;

    // open on pointerenter of the LI
    li.addEventListener('pointerenter', (ev) => {
      openImmediate(li);
    }, { passive: true });

    // when pointer leaves the LI, schedule a close
    li.addEventListener('pointerleave', (ev) => {
      // If pointer is moving into the submenu, we want to keep open.
      // The submenu itself will clear this timer on its pointerenter.
      scheduleClose(li);
    });

    // also attach listeners to the submenu container to cancel close while pointer is inside it
    const submenu = li.querySelector('ul.sub-menu-lists, .megamenu_megamenu .sub-menu-block');
    if (submenu) {
      submenu.addEventListener('pointerenter', () => {
        clearTimer(li);
      }, { passive: true });

      submenu.addEventListener('pointerleave', () => {
        scheduleClose(li);
      });
    }

    // keyboard accessibility: open on focus and close on blur (short delay to allow tabbing)
    const trigger = li.querySelector('a, button');
    if (trigger) {
      trigger.addEventListener('focus', () => {
        openImmediate(li);
      });
      trigger.addEventListener('blur', () => {
        // delay slightly so tab into submenu doesn't immediately close
        setTimeout(() => {
          if (!li.contains(document.activeElement)) scheduleClose(li);
        }, 10);
      });

      // click/touch behaviour: 1st tap opens, 2nd taps navigates
      trigger.addEventListener('click', (e) => {
        if (hasSub && !li.classList.contains('is-open')) {
          e.preventDefault();
          openImmediate(li);
        }
        // if already open, let click navigate normally (or you can customise)
      });
    }
  });

  // close if click outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('nav#AccessibleNav')) {
      topItems.forEach(li => {
        li.classList.remove('is-open');
        const trigger = li.querySelector('a, button');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }
  }, { passive: true });
});
